module.exports = __webpack_public_path__ + "static/tiempo-intro-9257b785f13aa844704bbd61d510280b.mp4";